import {
  Component,
  inject,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SidebarModule } from 'primeng/sidebar';

import { Product } from '../cart.model';
import { CartService } from '../cart.service';
import { QuantityCounterComponent } from '../quantity-counter/quantity-counter.component';
import { FormsModule } from '@angular/forms';
import { BadgeModule } from 'primeng/badge';
import { Subscription } from 'rxjs/internal/Subscription';
import { Tooltip, TooltipModule } from 'primeng/tooltip';
import { IngredientNamePipe } from 'src/app/pipes/ingredient-name/ingredient-name.pipe';
import { RouterLink } from '@angular/router';
import _ from 'lodash';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    ButtonModule,
    NgFor,
    NgIf,
    QuantityCounterComponent,
    InputTextareaModule,
    FormsModule,
    SidebarModule,
    BadgeModule,
    TooltipModule,
    IngredientNamePipe,
    RouterLink,
  ],
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss',
})
export class CartComponent {
  cartService = inject(CartService);
  sidebarVisible: boolean = false;
  totalElements: number = 0;
  subtotal: number = 0;
  subscription: Subscription;
  subscriptionSubtotal: Subscription;

  @ViewChild(Tooltip) tooltip!: Tooltip;
  @ViewChildren(Tooltip) tooltips!: QueryList<Tooltip>;

  cartWrapper!: HTMLElement;
  cartEmptyBtn!: HTMLElement;
  productAddBtn!: HTMLElement;
  productList!: Product[];
  lodash;

  constructor() {
    this.totalElements = this.cartService.setTotalElements();
    this.subtotal = this.cartService.calculateSubtotalAmount();
    this.subscription = this.cartService.totalElements$.subscribe(
      (data: number) => {
        this.totalElements = data;
      }
    );

    this.subscriptionSubtotal = this.cartService.subtotal$.subscribe(
      (data: number) => {
        this.subtotal = data;
      }
    );

    this.lodash = _;
  }

  changeQuantity(index: number, value: number | null) {
    if (value !== null) {
      this.cartService.changeProductQuantity(index, value);
    }
  }

  removeProduct(index: number) {
    this.cartService.removeProduct(index);
  }

  emptyCart() {
    this.cartService.emptyCart();
    this.totalElements = 0;
  }

  private findTooltipById(searchId: string): Tooltip | undefined {
    return this.tooltips.find(
      tooltip => tooltip.el.nativeElement.id === searchId
    );
  }

  clickTooltip(index: number) {
    const tooltip = this.findTooltipById(`show-${index}`);
    if (tooltip) {
      this.tooltips.forEach(element => {
        element.deactivate();
      });
      tooltip.active ? tooltip.deactivate() : tooltip.activate();
    }
  }
}
